import { InsightsSourceDescription } from '@upright/ui/common/upright/core/impact-lenses/insights/source-description/source-description';
import { InsightsSourceDescriptionTooltipContent } from '@upright/ui/common/upright/core/impact-lenses/insights/source-description/source-description-tooltip';

export const insightsLensTexts = {
  SourceDescription: InsightsSourceDescription,
  SourceTooltipContent: InsightsSourceDescriptionTooltipContent,
  LensTitle: () => {
    return <>Company insights</>;
  },
  LensDescription: () => {
    return <>Company's perspective to its impact</>;
  },
  LensTooltipContent: () => {
    return (
      <>
        Insights that represent the company's perspective to its impact. The insights may be submitted directly by the
        company, or collected by Upright from the company's public reporting.
      </>
    );
  },
};
